import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ChatProvider } from "@/lib/chat";
import { analytics } from "@/lib/analytics";
import { MobileBlocked } from "@/components/MobileBlocked";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import StatusPage from "@/pages/StatusPage";
import LoginPage from "@/pages/LoginPage";
import ClientPage from "@/pages/ClientPage";
import AdminPage from "@/pages/AdminPage";
import "@/App.css";

const Protected = ({ children }) => {
  const { user, loading, mobileBlocked } = useAuth();
  const location = useLocation();
  if (loading) return <div className="tc-login" data-testid="app-loading"><div className="tc-login__logo"><span className="tc-login__mark">TC</span><span className="tc-login__wordmark">Total Chat</span></div><p className="tc-login__sub">Loading your workspace…</p></div>;
  if (mobileBlocked) return <MobileBlocked />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <ChatProvider>{children}</ChatProvider>;
};

function App() {
  useEffect(() => { analytics.install(); }, []);
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AuthProvider>
          <Routes>
            <Route path="/status" element={<StatusPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/client/*" element={<Protected><ClientPage /></Protected>} />
            <Route path="/admin/:section?" element={<Protected><AdminPage /></Protected>} />
            <Route path="*" element={<Navigate to="/client" replace />} />
          </Routes>
          <Toaster position="bottom-left" richColors closeButton toastOptions={{ style: { fontFamily: "Lato, sans-serif" } }} />
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
